import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton,ManText,ManCard } from '@craft-design-system/core-components-react';
import ifav from './warning_info.png';
// import { ManCard} from '@craft-design-system/core-components-react';

import { Button, Popover, OverlayTrigger } from 'react-bootstrap';

const boldStyle = {
  fontWeight: 'bold'
};
const Charging_mode = ({ value }) => {
  const [Charging_mode, set_charging_mode] = useState(null);
  

//   //console.log('test',value)

const popover = (
  <Popover id="popover-basic">
    <Popover.Body>
      <b>Disclaimer:</b> Data may be missing during the charging process due to provision issues. This topic is solved over time with rollout of latest software stages. When data on charging cycles is available, all respective KPIs are displayed as intended. The issue has been reported to the respective teams.
      <br /><br />

      <b>Definition:</b>
      <br />
      This KPI displays the total number of charging cycles since start of data acquisition.
      <br /><br />

      <b>Telematic raw data for this KPI:</b>
      <br />
      <b>TBM3:</b>
      <br />
      • highvoltsysmode
      <br />
      • batterycurrent
      <br />
      • energylevel
      <br />
      <br />
      <b>CM4:</b>
      <br />
      • highvoltsysmode
      <br />
      • batterycurrent
      <br />
      • batcurrcbp
      <br />
      • energylevel
      <br />
      • energylevelcbp
      
      <br /><br />

      <b>Time series data:</b>
      <br />
      If multiple vehicles are selected, the total number of charging cycles since start of data acquisition is displayed for the top 5 vehicles. Additionally, the average value on the total number of charging cycles over all selected vehicles is displayed. Days without data are not taken into account for the calculation.
    </Popover.Body>
  </Popover>
);


  useEffect(() => {
    try {
        set_charging_mode(JSON.parse(value));
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
    <ManCard className='card_battery' appearance="soft" outline="false">
      <ManText className="card-title-text" variant="component-l" as="span" size="l" 
       style={{}}>
      Total number of charging cycles
      </ManText>
      <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
      <img className="man-logovv1" src={ifav} style={{color: 'red'}}/>
      </OverlayTrigger>

      {Charging_mode && Charging_mode.data && Charging_mode.data.length > 0 
        ? <Plot 
        data={Charging_mode.data} 
        layout={{
            ...Charging_mode.layout,
            autosize: true,
            responsive: true,
            margin: { t: 10, r: 10, l: 10, b: 120 }
        }}
        style={{ width: '100%', height: '85%' }}
        useResizeHandler={true}
    />
        : <ManText className="title" variant="body-l" as="span">
          No Data available for Trucks
        </ManText>
      }
    </ManCard>
  );
};

Charging_mode.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Charging_mode;
